import React from 'react';
import { isMobile } from 'react-device-detect';
import SubHeader from '../Layout/SubHeader';
import Player from '../Player/Player';
import RoomsPanel from '../RoomsPanel/RoomsPanel';
import RoomsMenu from '../RoomsMenu/RoomsMenu';
import useWindowSize from '../../hooks/useWindowSize';
import ServerApiPopup from '../ServerApiPopup/ServerApiPopup';
import PopupManager from '../Popups/PopupManager';
import Snackbar from '../Layout/Snackbar';
import { MobilePortraitHeight } from '../../model/constants';
import Header from '../Layout/Header';


const Configurator = () => {
  const windowsSize = useWindowSize();
  const isPortrait = () => windowsSize.height > windowsSize.width;
  const isMobileLandscape = () => isMobile && windowsSize.height <= MobilePortraitHeight;

  return (
    <div className="configurator">
      {!isMobileLandscape() && <Header isMobilePortrait={isPortrait()} />}
      {!isMobileLandscape() && <SubHeader isMobilePortrait={isPortrait()} />}
      <div className={`container-content${isMobileLandscape() ? ' is-mobile-landscape' : ''}`}>
        <Player isMobileLandscape={isMobileLandscape()} />
        {isPortrait() && !isMobileLandscape() && <RoomsMenu />}
        {!isMobileLandscape() && <RoomsPanel />}
        {!isMobileLandscape() && <Snackbar />}
        {!isMobileLandscape() && <PopupManager />}
      </div>
      <ServerApiPopup />
    </div>
  );
};

export default Configurator;
